import { cn } from "../../../helpers/utils";

export default function OutlineButton({
  label,
  className,
  type = "button",
  ...props
}) {
  return (
    <button
      type={type}
      className={cn(
        "rounded-md px-4 py-3 font-league-medium w-full border transition-colors",
        props.disabled
          ? "border-disableVestelColor text-disableVestelColor bg-white cursor-not-allowed"
          : "border-vestelColor text-vestelColor bg-white hover:bg-vestelColor hover:text-white",
        className
      )}
      {...props}
    >
      {label}
    </button>
  );
}
